import Vue, { PluginObject } from "vue";
import axios from "axios";
import { authModule, alert } from "@/store";

const config = {
  baseURL: "/api/v1",
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const Axios = axios.create(config);

Axios.interceptors.request.use(
  (config) => {
    if (authModule.token) {
      config.headers!.Authorization = "bearer " + authModule.token;
    }
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  },
);

// Add a response interceptor
Axios.interceptors.response.use(
  (response) => {
    // Do something with response data
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Don't auto-logout on logout endpoint itself
      const requestUrl = error.config?.url || "";
      if (requestUrl.includes("/logout")) {
        return Promise.reject(error);
      }
      alert.setError(error);
      return authModule.logout();
    }

    return Promise.reject(error);
  },
);

const Plugin: PluginObject<any> = {
  install(Vue, options) {
    Object.defineProperties(Vue.prototype, {
      axios: {
        get() {
          return Axios;
        },
      },
      $axios: {
        get() {
          return Axios;
        },
      },
    });
  },
};

Vue.use(Plugin);

export default Axios;
